import qs from 'qs'
import { useQuery } from 'react-query'
import { getJSON } from '../../../../../common/services/api'
import type { CommunicationRecord } from '../utils/types'
import {
  COMMUNICATION_RECORDS_QUERY_KEY,
  COMMUNICATION_RECORDS_URL
} from './useCommunicationRecordCreate'

type UseCommunicationRecordsListProps = {
  residentId?: string
  enabled?: boolean
}

type UseCommunicationRecordsListReturn = {
  communicationRecords: CommunicationRecord[]
  isLoading: boolean
  refetch: () => void
}

export const useCommunicationRecordsList = ({
  residentId,
  enabled = true
}: UseCommunicationRecordsListProps = {}): UseCommunicationRecordsListReturn => {
  const queryParams = qs.stringify({
    ...(residentId && { resident: residentId })
  })

  const url = queryParams
    ? `${COMMUNICATION_RECORDS_URL}?${queryParams}`
    : COMMUNICATION_RECORDS_URL

  const { data, isLoading, refetch } = useQuery<{
    result: CommunicationRecord[]
  }>([COMMUNICATION_RECORDS_QUERY_KEY, residentId], () => getJSON({ url }), {
    enabled: enabled && !!residentId
  })

  return {
    communicationRecords: data?.result || [],
    isLoading,
    refetch
  }
}
